var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m392 0h-272c-66.168 0-120 53.832-120 120v272c0 66.168 53.832 120 120 120h272c66.168 0 120-53.832 120-120v-272c0-66.168-53.832-120-120-120zm80 392c0 44.112-35.888 80-80 80h-272c-44.112 0-80-35.888-80-80v-272c0-44.112 35.888-80 80-80h272c44.112 0 80 35.888 80 80zm-196-284v297c0 11.046-8.954 20-20 20s-20-8.954-20-20v-297c0-11.046 8.954-20 20-20s20 8.954 20 20zm-77 70v227c0 11.046-8.954 20-20 20s-20-8.954-20-20v-227c0-11.046 8.954-20 20-20s20 8.954 20 20zm-78 143v84c0 11.046-8.954 20-20 20s-20-8.954-20-20v-84c0-11.046 8.954-20 20-20s20 8.954 20 20zm233-83v167c0 11.046-8.954 20-20 20s-20-8.954-20-20v-167c0-11.046 8.954-20 20-20s20 8.954 20 20zm78 123v44c0 11.046-8.954 20-20 20s-20-8.954-20-20v-44c0-11.046 8.954-20 20-20s20 8.954 20 20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistogram);
export default __webpack_public_path__ + "static/media/histogram.7f96bf53b84cdb8b38cb6476f470149e.svg";
export { ForwardRef as ReactComponent };